if (!customElements.get("accordion-component")) {
  class AccordionComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.accordionSections = this.querySelectorAll(".js-section");
      [...this.accordionSections].forEach((acc) => {
        const head = acc.querySelector(".overview__title");
        const content = acc.querySelector(".overview__content");
        head.addEventListener("click", () => {
          if (content.style.maxHeight) {
            this.closeAccordion(acc);
          } else {
            [...this.accordionSections].forEach((accordion) =>
              this.closeAccordion(accordion)
            );
            this.openAccordion(acc);
          }
        });
      });
    }

    openAccordion(accordion) {
      const content = accordion.querySelector(".overview__content");
      accordion.classList.add("is-active");
      content.style.maxHeight = content.scrollHeight + "px";
    }

    closeAccordion(accordion) {
      const content = accordion.querySelector(".overview__content");
      accordion.classList.remove("is-active");
      content.style.maxHeight = null;
    }
  }

  customElements.define("accordion-component", AccordionComponent);
}
